//import inMemoryJWT from '../auth/inMemoryJwt';
import { urlServer } from '../config/GlobalConstant'
import {
    SEE_COMMENTS, ADD_COMMENT, ADD_COMMENT_MULTI, SEE_COMMENTS_MULTI, IS_LOADING_COMMENTS, IS_LOADING_COMMENTS_MULTI, DELETE_COMMENTS, DELETE_COMMENTS_MULTI, SEE_REPLY_COMMENTS, ADD_REPLY_COMMENT, IS_LOADING_REPLY_COMMENTS,
    ADD_COUNT_COMMENT_POST_PROFILE, ADD_COUNT_COMMENT_POST_HOME, DELETE_REPLY_COMMENTS, IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE,
    DELETE_COUNT_COMMENT_POST_HOME, DELETE_COUNT_COMMENT_POST_PROFILE
} from './types'
import inMemoryJWT from '../auth/inMemoryJwt';


///comment actions
export const addComment = (data) => dispatch => {
    console.log();
    dispatch({
        type: "ADD_COMMENT_FROM_ANOTHER",
        payload: data
    })
}
export const createComment = (formData, postID, poisProfessional, noAdd) => async dispatch => {
    var oringinScreen = "profile"
    //const accessToken= inMemoryJWT.getToken()
    formData.append('contentID', postID)
    await fetch(`${urlServer}comments/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                if (noAdd) {
            
                }
                else {
                    dispatch({
                        type: IS_LOADING_COMMENTS
                    });
                    dispatch({
                        type: ADD_COMMENT,
                        payload: respJson.data
                    })
                }

                dispatch({
                    type: IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE
                })
                dispatch({
                    type: ADD_COUNT_COMMENT_POST_PROFILE,
                    payload: postID
                })

            }

            /*  if (oringinScreen === "profile") {
                 dispatch({
                     type: IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE
                 })
                 dispatch({
                     type: ADD_COUNT_COMMENT_POST_PROFILE,
                     payload: postID
                 })
             }
             if (oringinScreen === "home") {
                 dispatch({
                     type: ADD_COUNT_COMMENT_POST_HOME,
                     payload: postID
                 })
             } */

        })
        .catch(error => {
            console.log()
        })
}

export const seeComments = (postID, isMultiple) => async dispatch => {

    //const accessToken= inMemoryJWT.getToken()
    await fetch(`${urlServer}comments/post-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(
            {
                postID: postID
            }

        ) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            if (isMultiple) {
                console.log()
                dispatch({
                    type: IS_LOADING_COMMENTS_MULTI
                })
                dispatch({
                    type: SEE_COMMENTS_MULTI,
                    payload: respJson.data
                })
            }
            else {
               if(respJson.success){
                dispatch({
                    type: IS_LOADING_COMMENTS
                })
                dispatch({
                    type: SEE_COMMENTS,
                    payload: respJson.data
                })
               }else{
                dispatch({
                    type: IS_LOADING_COMMENTS
                })
                dispatch({
                    type: SEE_COMMENTS,
                    payload: []
                })
               }
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeReplyComments = (commentID) => async dispatch => {

    console.log()
    dispatch({
        type: IS_LOADING_REPLY_COMMENTS
    });
    // const accessToken= inMemoryJWT.getToken()
    await fetch(`${urlServer}comments/comment-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(
            {
                commentID: commentID
            }

        ) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            dispatch({
                type: SEE_REPLY_COMMENTS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteComment = (commentID, postID, isMulti) => async dispatch => {
    console.log()
    var oringinScreen = "profile"
    //const accessToken= inMemoryJWT.getToken()
    await fetch(`${urlServer}comments/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(
            {
                commentID: commentID
            }

        ) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (isMulti) {
                dispatch({
                    type: IS_LOADING_COMMENTS_MULTI
                });
                dispatch({
                    type: DELETE_COMMENTS_MULTI,
                    payload: commentID
                })
            }
            else {
                dispatch({
                    type: IS_LOADING_COMMENTS
                });
                dispatch({
                    type: DELETE_COMMENTS,
                    payload: commentID
                })
            }

            if (oringinScreen === "profile") {
                dispatch({
                    type: IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE
                })
                dispatch({
                    type: DELETE_COUNT_COMMENT_POST_PROFILE,
                    payload: postID
                })
            }
            if (oringinScreen === "home") {
                dispatch({
                    type: DELETE_COUNT_COMMENT_POST_HOME,
                    payload: commentID
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const createReplyComment = (formData, commentID, isProfessional) => async dispatch => {
    //const accessToken= inMemoryJWT.getToken()
    formData.append('commentID', commentID)
    await fetch(`${urlServer}commentresponses/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_REPLY_COMMENTS
            });
            dispatch({
                type: ADD_REPLY_COMMENT,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteReplyComment = (id) => async dispatch => {
    console.log()
    //const accessToken= inMemoryJWT.getToken()
    await fetch(`${urlServer}api/replytocomment/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(
            {
                id: id
            }

        ) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_REPLY_COMMENTS
            });
            dispatch({
                type: DELETE_REPLY_COMMENTS,
                payload: id
            });
        })
        .catch(error => {
            console.log()
        })
}

